export default "__VITE_ASSET__v0v7VgGe__"